<template>
  <div>
    <v-row>
      <v-col cols="7">
        <v-data-iterator
          :no-data-text="noDataText"
          :items="disponibilidades"
          :items-per-page.sync="itemsPerPage"
          :page="pageGeral"
          :search="searchGeral"
          :no-results-text="noResultsText"
          hide-default-footer
        >
          <template v-slot:header>
            <v-row justify="end">
              <v-col cols="4">
                <v-text-field
                  v-model="searchGeral"
                  clearable
                  hide-details
                  prepend-inner-icon="mdi-magnify"
                  label="Busca"
                />
              </v-col>
            </v-row>
          </template>
          <template v-slot:default="props">
            <v-data-table
              dense
              :headers="headersGeral"
              :items="props.items"
              hide-default-footer
              class="elevation-1"
              disable-pagination
              disable-sort
            />
          </template>

          <template v-slot:footer>
            <v-row class="mt-2" align="baseline" justify="center" dense>
              <div class="ml-4 mb-2 grey--text">
                <p>Total de Pausas: {{ qtdRegistrosGeral }}</p>
              </div>
              <v-spacer />
              <div class="pb-5">
                <ListPagination
                  :page="pageGeral"
                  :numberOfPages="numberOfPagesGeral"
                  @firstPage="firstPage()"
                  @formerPage="formerPage()"
                  @nextPage="nextPage()"
                  @lastPage="lastPage()"
                />
              </div>
            </v-row>
          </template>
        </v-data-iterator>
      </v-col>

      <v-col cols="4">
        <div class="text-h5 text-center font-italic">Disponibilidade Operador</div>
        <DonutChart :valores="porcentagensDisponibilidade" />
      </v-col>
    </v-row>
    <v-row>
      <ExpandListInterno :dadosOperador="dadosOperador" />
    </v-row>
  </div>
</template>

<script>
import moment from 'moment'

import ListPagination from '@/componentes/ListPagination'

import DonutChart from './DonutChart'
import ExpandListInterno from './ExpandListInterno'

export default {
  name: 'ResumeDisponibilidade',
  components: { DonutChart, ExpandListInterno, ListPagination },
  props: ['operador'],
  data: () => ({
    noDataText: process.env.VUE_APP_NO_DATA_TEXT,
    noResultsText: process.env.VUE_APP_NO_RESULTS_TEXT,
    disponibilidades: [],
    itemsPerPage: 20,
    searchGeral: '',
    pageGeral: 1,
    porcentagensDisponibilidade: [],
    dadosOperador: '',
    headersGeral: [
      {
        text: 'Pausa',
        value: 'pausa',
        align: 'left',
      },
      {
        text: 'Quantidade',
        value: 'quantidade',
        align: 'right',
      },
      {
        text: 'Tempo',
        value: 'tempo',
        align: 'left',
      },
    ],
  }),

  computed: {
    qtdRegistrosGeral() {
      return this.disponibilidades.length
    },

    numberOfPagesGeral() {
      return Math.ceil(this.disponibilidades.length / this.itemsPerPage)
    },
  },

  methods: {
    firstPage() {
      if (this.pageGeral > 1) {
        this.pageGeral = 1
      }
    },

    formerPage() {
      if (this.pageGeral > 1) {
        this.pageGeral = this.pageGeral - 1
      }
    },

    nextPage() {
      if (this.pageGeral < this.numberOfPagesGeral) {
        this.pageGeral = this.pageGeral + 1
      }
    },

    lastPage() {
      if (this.pageGeral < this.numberOfPagesGeral) {
        this.pageGeral = this.numberOfPagesGeral
      }
    },

    updateChart(disponivel, pausado, emLigacao) {
      this.porcentagensDisponibilidade.splice(0)
      this.porcentagensDisponibilidade.push(disponivel)
      this.porcentagensDisponibilidade.push(pausado)
      this.porcentagensDisponibilidade.push(emLigacao)
      this.porcentagensDisponibilidade.splice(0, 1, this.porcentagensDisponibilidade[0])
    },
  },

  watch: {
    operador: {
      deep: true,
      immediate: true,
      handler() {
        this.disponibilidades.splice(0)
        let pausas = Object.keys(this.operador.TempoPausaPorTipoDePausa)
        this.disponibilidades = pausas.map(pausa => ({
          pausa,
          quantidade: this.operador.TempoPausaPorTipoDePausa[`${pausa}`].quantidade,
          tempo: this.operador.TempoPausaPorTipoDePausa[`${pausa}`].seconds,
        }))

        this.dadosOperador = this.operador

        let disponivel = moment.duration(this.operador.horaDisponivel).asSeconds()
        let pausado = moment.duration(this.operador.horaPausado).asSeconds()
        let emLigacao = moment.duration(this.operador.horasEmLigação).asSeconds()
        this.updateChart(disponivel, pausado, emLigacao)
      },
    },
  },
}
</script>
